<a
  data-toggle="modal"
  data-target="#selected-calendar"
  href="#"
  class="calendar-link"
  >{{ titleButton }}<ng-content></ng-content
></a>

<div id="selected-calendar" class="modal fade" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <strong class="calendar-title">{{ titleCalendar }}</strong>
      </div>

      <div class="modal-body">
        <div class="subtitle-wrapper" *ngIf="subtitleCalendar">
          <span class="calendar-subtitle">{{ subtitleCalendar }}</span>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <div class="selected-date"></div>
          </div>
        </div>
      </div>
      
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-border-orange pull-left"
          data-dismiss="modal"
          (click)="onCloseClick()"
        >
          Fechar
        </button>
        <button
          type="submit"
          class="btn btn-full-orange pull-right"
          (click)="onSaveClick()"
          data-dismiss="modal"
        >
          Salvar
        </button>
      </div>
    </div>
  </div>
</div>
